/**
 * Service for generating calendar links
 * Supports Google Calendar, Outlook, and iCal formats
 */

// Helper function to format date for calendar URLs
function formatCalendarDate(date) {
  // Format: YYYYMMDDTHHMMSSZ
  return date.toISOString().replace(/-|:|\.\d+/g, '');
}

// Helper to encode parameters for URL
function encodeCalendarParams(params) {
  return Object.keys(params)
    .map(key => `${key}=${encodeURIComponent(params[key])}`)
    .join('&');
}

// Generate calendar links based on type
export function generateCalendarLink(calendarData) {
  const { title, description, location, startDate, endDate, type } = calendarData;

  // Default end date if not provided (1 hour after start)
  const end = endDate || new Date(startDate.getTime() + 60 * 60 * 1000);

  // Format dates
  const formattedStart = formatCalendarDate(startDate);
  const formattedEnd = formatCalendarDate(end);

  let calendarUrl = '';

  switch (type.toLowerCase()) {
    case 'google':
      // Google Calendar
      const googleParams = {
        action: 'TEMPLATE',
        text: title,
        details: description,
        location: location,
        dates: `${formattedStart}/${formattedEnd}`
      };

      calendarUrl = `https://calendar.google.com/calendar/render?${encodeCalendarParams(googleParams)}`;
      break;

    case 'outlook':
      // Outlook.com calendar - formato aggiornato
      // Formato corretto per Outlook Web:
      // https://outlook.office.com/calendar/action/compose?subject=TITLE&body=DESCRIPTION&location=LOCATION&startdt=STARTDATE&enddt=ENDDATE

      const outlookParams = {
        subject: title,
        body: description,
        location: location,
        startdt: formattedStart,
        enddt: formattedEnd
      };

      calendarUrl = `https://outlook.office.com/calendar/action/compose?${encodeCalendarParams(outlookParams)}`;
      break;

    case 'ical':
      // iCal format (download .ics file)
      const icalContent = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'BEGIN:VEVENT',
        `DTSTART:${formattedStart}`,
        `DTEND:${formattedEnd}`,
        `SUMMARY:${title}`,
        `DESCRIPTION:${description}`,
        `LOCATION:${location}`,
        'END:VEVENT',
        'END:VCALENDAR'
      ].join('\n');

      const blob = new Blob([icalContent], { type: 'text/calendar;charset=utf-8' });
      const icalUrl = URL.createObjectURL(blob);

      // Create temporary link and trigger download
      const link = document.createElement('a');
      link.href = icalUrl;
      link.setAttribute('download', `${title.replace(/\s+/g, '-')}.ics`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // No need to return URL for iCal as we've already triggered the download
      return;

    default:
      console.error(`Calendar type "${type}" not supported`);
      return;
  }

  // Open the calendar URL in a new tab
  window.open(calendarUrl, '_blank');
}

export default {
  generateCalendarLink
};